import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"

import Bookings from "../../containers/bookings/bookings"
import BookingWrap from "../../containers/booking/booking"
import Error404 from "../../containers/errors/404"
import { ReadOnlyProvider } from "../providers/read-only"

/**
 * Routes for read-only third-party auditor accounts.
 *
 * Server-side enforcement lives in firestore.rules (userIsAuditor never
 * grants write). This router additionally narrows the surface area an
 * auditor can navigate to, and wraps the rendered tree in a
 * ReadOnlyProvider so write-bearing UI controls hide themselves.
 */
function AuditorPageRoutes() {
    return (
        <ReadOnlyProvider value={true}>
            <Switch>
                <Redirect from="/" to="/bookings" exact />
                <Redirect from="/login" to="/bookings" exact />

                <Route path="/bookings" component={Bookings} />
                <Route path="/booking/:id" component={BookingWrap} />

                <Route path="*" component={Error404} />
            </Switch>
        </ReadOnlyProvider>
    )
}

export default AuditorPageRoutes
